var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-container"},[_vm._v(" Tips ")])
}
var staticRenderFns = []

export { render, staticRenderFns }